import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type { AppState } from 'redux-store';

const deleteDeviceThunk = createAsyncThunk(
  'devices/deleteDeviceThunk',
  async (serials: string, thunkAPI) => {
    const state = thunkAPI.getState() as AppState;
    const userId = state.profile.profile?.id;

    try {
      const apiPointName =
        userId === 'anonymous' ? 'anonymousDeleteDevice' : 'deleteDevice';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        urlParams: { serials },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default deleteDeviceThunk;
